export const professionServiceData = [
    {
        profession: { label: 'AC Repair', value: 'AC Repair' },
        services: [
            { label: 'AC Gas Charging', value: 'AC Gas Charging' },
            { label: 'AC Installation', value: 'AC Installation' },
            { label: 'AC Noise Reduction', value: 'AC Noise Reduction' },
            { label: 'AC Remote Repair', value: 'AC Remote Repair' },
            { label: 'AC Sensor Repair', value: 'AC Sensor Repair' },
            { label: 'Air Duct Cleaning', value: 'Air Duct Cleaning' },
            { label: 'Compressor Repair', value: 'Compressor Repair' },
            { label: 'Condenser Coil Repair', value: 'Condenser Coil Repair' },
            { label: 'Evaporator Coil Cleaning', value: 'Evaporator Coil Cleaning' },
            { label: 'Filter Cleaning', value: 'Filter Cleaning' },
            { label: 'Refrigerant Refilling', value: 'Refrigerant Refilling' },
            { label: 'Thermostat Repair', value: 'Thermostat Repair' },
        ],
    },
    {
        profession: { label: 'Appliance Repair (TV, Washing Machine, Refrigerator)', value: 'Appliance Repair' },
        services: [
            { label: 'Appliance Installation', value: 'Appliance Installation' },
            { label: 'Appliance Repair', value: 'Appliance Repair' },
            { label: 'Backlight Repair', value: 'Backlight Repair' },
            { label: 'HDMI Port Repair', value: 'HDMI Port Repair' },
            { label: 'LED Repair', value: 'LED Repair' },
            { label: 'Motherboard Repair', value: 'Motherboard Repair' },
            { label: 'Power Supply Repair', value: 'Power Supply Repair' },
            { label: 'Remote Control Repair', value: 'Remote Control Repair' },
            { label: 'Signal Troubleshooting', value: 'Signal Troubleshooting' },
            { label: 'Smart TV Setup', value: 'Smart TV Setup' },
            { label: 'Sound Issues Fixing', value: 'Sound Issues Fixing' },
            { label: 'TV Tuning', value: 'TV Tuning' },
        ],
    },
    {
        profession: { label: 'Aquarium', value: 'Aquarium' },
        services: [
            {
                label: 'New Aquarium Installation',
                value: 'New Aquarium Installation',
                subServices: [
                    { value: 'Freshwater' },
                    { value: 'Saltwater' },
                    { value: 'Planted' },
                    { value: 'Marine' },
                    { value: 'Office Aquarium' },
                ],
            },
            {
                label: 'Aquarium Cleaning & Maintenance',
                value: 'Aquarium Cleaning & Maintenance',
                subServices: [
                    { value: 'Freshwater' },
                    { value: 'Saltwater' },
                    { value: 'Planted' },
                    { value: 'Marine' },
                    { value: 'Office Aquarium' },
                ],
            },
            {
                label: 'Filter & Pump Setup',
                value: 'Filter & Pump Setup',
                subServices: [
                    { value: 'Freshwater' },
                    { value: 'Saltwater' },
                    { value: 'Planted' },
                    { value: 'Marine' },
                    { value: 'Office Aquarium' },
                ],
            },
            {
                label: 'Water Change Service',
                value: 'Water Change Service',
                subServices: [
                    { value: 'Freshwater' },
                    { value: 'Saltwater' },
                    { value: 'Planted' },
                    { value: 'Marine' },
                    { value: 'Office Aquarium' },
                ],
            },
            {
                label: 'Lighting & Decoration Setup',
                value: 'Lighting & Decoration Setup',
                subServices: [
                    { value: 'Freshwater' },
                    { value: 'Saltwater' },
                    { value: 'Planted' },
                    { value: 'Marine' },
                    { value: 'Office Aquarium' },
                ],
            },
            {
                label: 'Fish Health & Medicine',
                value: 'Fish Health & Medicine',
                subServices: [
                    { value: 'Freshwater' },
                    { value: 'Saltwater' },
                    { value: 'Planted' },
                    { value: 'Marine' },
                    { value: 'Office Aquarium' },
                ],
            },
            {
                label: 'Custom Tank Design',
                value: 'Custom Tank Design',
                subServices: [
                    { value: 'Freshwater' },
                    { value: 'Saltwater' },
                    { value: 'Planted' },
                    { value: 'Marine' },
                    { value: 'Office Aquarium' },
                ],
            },
        ],
    },
    {
        profession: { label: 'Beauty & Wellness', value: 'Beauty & Wellness' },
        services: [
            { label: 'Anti-Aging Treatment', value: 'Anti-Aging Treatment' },
            { label: 'Anti-Hairfall Treatment', value: 'Anti-Hairfall Treatment' },
            { label: 'Beard Coloring', value: 'Beard Coloring' },
            { label: 'Beard Styling', value: 'Beard Styling' },
            { label: 'Bleaching', value: 'Bleaching' },
            { label: 'Body Polishing', value: 'Body Polishing' },
            { label: 'Bridal Makeup', value: 'Bridal Makeup' },
            { label: 'Dandruff Treatment', value: 'Dandruff Treatment' },
            { label: 'Hair Coloring', value: 'Hair Coloring' },
            { label: 'Hair Highlights', value: 'Hair Highlights' },
            { label: 'Hair Perming', value: 'Hair Perming' },
            { label: 'Hair Spa', value: 'Hair Spa' },
            { label: 'Hair Straightening', value: 'Hair Straightening' },
            { label: 'Haircut', value: 'Haircut' },
            { label: 'Head Massage', value: 'Head Massage' },
            { label: 'Keratin Treatment', value: 'Keratin Treatment' },
            { label: 'Manicure', value: 'Manicure' },
            { label: 'Nail Art', value: 'Nail Art' },
            { label: 'Pedicure', value: 'Pedicure' },
            { label: 'Scalp Treatment', value: 'Scalp Treatment' },
            { label: 'Shaving', value: 'Shaving' },
            { label: 'Threading', value: 'Threading' },
        ],
    },
    {
        profession: { label: 'Car Wash at Home', value: 'Car Wash' },
        services: [
            { label: 'Car Wash', value: 'Car Wash' },
            { label: 'Car Detailing', value: 'Car Detailing' },
            { label: 'Car Polishing', value: 'Car Polishing' },
            { label: 'Car Waxing', value: 'Car Waxing' },
            { label: 'Interior Vacuuming', value: 'Interior Vacuuming' },
            { label: 'Foam Wash', value: 'Foam Wash' },
            { label: 'Engine Bay Cleaning', value: 'Engine Bay Cleaning' },
            { label: 'Headlight Restoration', value: 'Headlight Restoration' },
            { label: 'Waterless Wash', value: 'Waterless Wash' },
            { label: 'Ceramic Coating (Basic)', value: 'Ceramic Coating (Basic)' },
        ],
    },
    {
        profession: { label: 'Carpenter', value: 'Carpenter' },
        services: [
            { label: 'Door Repair & Installation', value: 'Door Repair & Installation' },
            { label: 'Window Repair', value: 'Window Repair' },
            { label: 'Wardrobe Making', value: 'Wardrobe Making' },
            { label: 'Modular Kitchen Fitting', value: 'Modular Kitchen Fitting' },
            { label: 'Furniture Assembly', value: 'Furniture Assembly' },
            { label: 'Bed Repair', value: 'Bed Repair' },
            { label: 'Shelf & Rack Installation', value: 'Shelf & Rack Installation' },
            { label: 'Lock & Hinge Fixing', value: 'Lock & Hinge Fixing' },
            { label: 'Custom Furniture', value: 'Custom Furniture' },
            { label: 'Polishing & Varnishing', value: 'Polishing & Varnishing' },
        ],
    },
    {
        profession: { label: 'Catering Services', value: 'Catering Services' },
        services: [
            { label: 'Wedding & Event Catering', value: 'Wedding & Event Catering' },
            { label: 'Birthday, Engagement, and Party Catering', value: 'Birthday, Engagement, and Party Catering' },
            { label: 'Corporate Lunch / Dinner Catering', value: 'Corporate Lunch / Dinner Catering' },
            { label: 'Traditional South Indian / North Indian Menu Setup', value: 'Traditional South Indian / North Indian Menu Setup' },
            { label: 'Live Counters', value: 'Live Counters' },
            { label: 'Buffet and Sit-Down Service Arrangements', value: 'Buffet and Sit-Down Service Arrangements' },
            { label: 'Tea, Coffee & Snacks Catering', value: 'Tea, Coffee & Snacks Catering' },
            { label: 'Home Functions & Puja Food Supply', value: 'Home Functions & Puja Food Supply' },
            { label: 'Outdoor Event Catering & Food Stall Setup', value: 'Outdoor Event Catering & Food Stall Setup' },
            { label: 'Disposable / Eco-friendly Utensils and Serving Setup', value: 'Disposable / Eco-friendly Utensils and Serving Setup' },
        ],
    },
    {
        profession: { label: 'Ceiling', value: 'Ceiling' },
        services: [
            { label: 'False Ceiling Design & Installation', value: 'False Ceiling Design & Installation' },
            { label: 'Ceiling Repair & Renovation', value: 'Ceiling Repair & Renovation' },
            { label: 'Wall Putty Application & Smoothing', value: 'Wall Putty Application & Smoothing' },
            { label: 'Decorative Ceiling Lighting Setup', value: 'Decorative Ceiling Lighting Setup' },
            { label: 'Painting & Primer Finishing After Putty', value: 'Painting & Primer Finishing After Putty' },
            { label: 'Moisture & Crack Treatment Before Putty', value: 'Moisture & Crack Treatment Before Putty' },
            { label: 'Cornice and Molding Design', value: 'Cornice and Molding Design' },
            { label: 'Ceiling Maintenance & Repainting', value: 'Ceiling Maintenance & Repainting' },
            { label: 'Ceiling Soundproofing or Insulation Layer Setup', value: 'Ceiling Soundproofing or Insulation Layer Setup' },
            { label: 'Ceiling Restoration for Old Buildings', value: 'Ceiling Restoration for Old Buildings' },
        ],
    },
    {
        profession: { label: 'Cleaning', value: 'Cleaning' },
        services: [
            { label: 'Bathroom Cleaning', value: 'Bathroom Cleaning' },
            { label: 'Carpet Cleaning', value: 'Carpet Cleaning' },
            { label: 'Chimney Cleaning', value: 'Chimney Cleaning' },
            { label: 'Curtain Cleaning', value: 'Curtain Cleaning' },
            { label: 'Deep Cleaning', value: 'Deep Cleaning' },
            { label: 'Duct Cleaning', value: 'Duct Cleaning' },
            { label: 'Floor Scrubbing', value: 'Floor Scrubbing' },
            { label: 'Gutter Cleaning', value: 'Gutter Cleaning' },
            { label: 'Home Cleaning', value: 'Home Cleaning' },
            { label: 'Kitchen Cleaning', value: 'Kitchen Cleaning' },
            { label: 'Leather Cleaning', value: 'Leather Cleaning' },
            { label: 'Mattress Cleaning', value: 'Mattress Cleaning' },
            { label: 'Office Cleaning', value: 'Office Cleaning' },
            { label: 'Pest Control', value: 'Pest Control' },
            { label: 'Pillow Cleaning', value: 'Pillow Cleaning' },
            { label: 'Post-Construction Cleaning', value: 'Post-Construction Cleaning' },
            { label: 'Pressure Washing', value: 'Pressure Washing' },
            { label: 'Shoe Cleaning', value: 'Shoe Cleaning' },
            { label: 'Sofa Cleaning', value: 'Sofa Cleaning' },
            { label: 'Stain Removal', value: 'Stain Removal' },
            { label: 'Tile and Grout Cleaning', value: 'Tile and Grout Cleaning' },
            { label: 'Window Cleaning', value: 'Window Cleaning' },
        ],
    },
    {
        profession: { label: 'Pest Control', value: 'Pest Control' },
        services: [
            {
                label: 'Eco-Friendly / Herbal / Odorless',
                value: 'Eco-Friendly / Herbal / Odorless',
                subServices: [
                    { value: 'General Pest Control' },
                    { value: 'Termite Treatment' },
                    { value: 'Mosquito / Fly Treatment' },
                    { value: 'Cockroach / Ant Control' },
                    { value: 'Bed Bug Control' },
                    { value: 'Rat / Rodent Control' },
                    { value: 'Disinfection / Sanitization Service' },
                ],
            },
            {
                label: 'Regular Chemical',
                value: 'Regular Chemical',
                subServices: [
                    { value: 'General Pest Control' },
                    { value: 'Termite Treatment' },
                    { value: 'Mosquito / Fly Treatment' },
                    { value: 'Cockroach / Ant Control' },
                    { value: 'Bed Bug Control' },
                    { value: 'Rat / Rodent Control' },
                    { value: 'Disinfection / Sanitization Service' },
                ],
            },
            {
                label: 'Imported Brands',
                value: 'Imported Brands',
                subServices: [
                    { value: 'General Pest Control' },
                    { value: 'Termite Treatment' },
                    { value: 'Mosquito / Fly Treatment' },
                    { value: 'Cockroach / Ant Control' },
                    { value: 'Bed Bug Control' },
                    { value: 'Rat / Rodent Control' },
                    { value: 'Disinfection / Sanitization Service' },
                ],
            },
        ],
    },
    {
        profession: { label: 'Drivers', value: 'Drivers' },
        services: [
            { label: 'Outstation Driver (Per Day)', value: 'Outstation Driver (Per Day)' },
            { label: 'Local Driver (Hourly)', value: 'Local Driver (Hourly)' },
            { label: 'Airport Pickup/Drop', value: 'Airport Pickup/Drop' },
            { label: 'Valet Driver', value: 'Valet Driver' },
            { label: 'Chauffeur on Contract', value: 'Chauffeur on Contract' },
            { label: 'Night Duty Driver', value: 'Night Duty Driver' },
            { label: 'Driver for Events', value: 'Driver for Events' },
            { label: 'Commercial License Driver', value: 'Commercial License Driver' },
        ],
    },
    {
        profession: { label: 'Electrician', value: 'Electrician' },
        services: [
            { label: 'Antenna Installation', value: 'Antenna Installation' },
            { label: 'Cable Management', value: 'Cable Management' },
            { label: 'Chandelier Installation', value: 'Chandelier Installation' },
            { label: 'Circuit Breaker Installation', value: 'Circuit Breaker Installation' },
            { label: 'Earthing', value: 'Earthing' },
            { label: 'Electrical Panel Upgrade', value: 'Electrical Panel Upgrade' },
            { label: 'Electrical Safety Inspection', value: 'Electrical Safety Inspection' },
            { label: 'Fan Installation', value: 'Fan Installation' },
            { label: 'Fan Motor Replacement', value: 'Fan Motor Replacement' },
            { label: 'Inverter Installation', value: 'Inverter Installation' },
            { label: 'Lighting Installation', value: 'Lighting Installation' },
            { label: 'Power Backup Installation', value: 'Power Backup Installation' },
            { label: 'Security System Installation', value: 'Security System Installation' },
            { label: 'Socket Repair', value: 'Socket Repair' },
            { label: 'Solar Panel Installation', value: 'Solar Panel Installation' },
            { label: 'Surge Protection', value: 'Surge Protection' },
            { label: 'Switchboard Repair', value: 'Switchboard Repair' },
            { label: 'Wall Mount Installation', value: 'Wall Mount Installation' },
        ],
    },
    {
        profession: { label: 'Interior Designers', value: 'Interior Designers' },
        services: [
            { label: 'Design Consultation', value: 'Design Consultation' },
            { label: '2D/3D Floor Planning', value: '2D/3D Floor Planning' },
            { label: 'Modular Kitchen Design', value: 'Modular Kitchen Design' },
            { label: 'Living Room Makeover', value: 'Living Room Makeover' },
            { label: 'Bedroom Wardrobe Design', value: 'Bedroom Wardrobe Design' },
            { label: 'False Ceiling Design', value: 'False Ceiling Design' },
            { label: 'Lighting Plan', value: 'Lighting Plan' },
            { label: 'End-to-End Execution', value: 'End-to-End Execution' },
            { label: 'Material & Color Selection', value: 'Material & Color Selection' },
            { label: 'Site Supervision', value: 'Site Supervision' },
        ],
    },
    {
        profession: { label: 'Laundry', value: 'Laundry' },
        services: [
            { label: 'Blanket Cleaning', value: 'Blanket Cleaning' },
            { label: 'Dry Cleaning', value: 'Dry Cleaning' },
            { label: 'Duvet Cleaning', value: 'Duvet Cleaning' },
            { label: 'Folding', value: 'Folding' },
            { label: 'Ironing', value: 'Ironing' },
            { label: 'Pickup and Delivery', value: 'Pickup and Delivery' },
            { label: 'Uniform Cleaning', value: 'Uniform Cleaning' },
            { label: 'Washing', value: 'Washing' },
        ],
    },
    {
        profession: { label: 'Mehndi Artist Services', value: 'Mehndi Artist Services' },
        services: [
            { label: 'Bridal Mehndi', value: 'Bridal Mehndi' },
            { label: 'Engagement & Festive Mehndi', value: 'Engagement & Festive Mehndi' },
            { label: 'Arabic & Indo-Arabic Designs', value: 'Arabic & Indo-Arabic Designs' },
            { label: 'Rajasthani, Marwari, and Traditional Designs', value: 'Rajasthani, Marwari, and Traditional Designs' },
            { label: 'Portrait Mehndi / Customized Name Designs', value: 'Portrait Mehndi / Customized Name Designs' },
            { label: 'Mehndi for Functions', value: 'Mehndi for Functions' },
            { label: 'Party & Guest Mehndi Packages', value: 'Party & Guest Mehndi Packages' },
            { label: 'Kids & Minimal Mehndi Designs', value: 'Kids & Minimal Mehndi Designs' },
            { label: 'Organic & Herbal Mehndi Application', value: 'Organic & Herbal Mehndi Application' },
            { label: 'Home Visit & Group Booking Services', value: 'Home Visit & Group Booking Services' },
        ],
    },
    {
        profession: { label: "Men's Salon", value: "Men's Salon" },
        services: [
            { label: 'Beard Coloring', value: 'Beard Coloring' },
            { label: 'Beard Styling', value: 'Beard Styling' },
            { label: 'Hair Coloring', value: 'Hair Coloring' },
            { label: 'Hair Highlights', value: 'Hair Highlights' },
            { label: 'Hair Perming', value: 'Hair Perming' },
            { label: 'Hair Spa', value: 'Hair Spa' },
            { label: 'Hair Straightening', value: 'Hair Straightening' },
            { label: 'Haircut', value: 'Haircut' },
            { label: 'Head Massage', value: 'Head Massage' },
            { label: 'Keratin Treatment', value: 'Keratin Treatment' },
            { label: 'Manicure', value: 'Manicure' },
            { label: 'Scalp Treatment', value: 'Scalp Treatment' },
            { label: 'Shaving', value: 'Shaving' },
            { label: 'Threading', value: 'Threading' },
        ],
    },
    {
        profession: { label: '2 Wheeler Mechanic', value: 'Two Wheeler Mechanic' },
        services: [
            {
                label: 'Scooty',
                value: 'Scooty',
                subServices: [
                    { value: 'Engine Work' },
                    { value: 'Oil Change' },
                    { value: 'Electrical Work' },
                    { value: 'Brake & Clutch Repair' },
                    { value: 'Wheel Alignment' },
                    { value: 'Chain & Sprocket' },
                    { value: 'Battery & Lights' },
                    { value: 'Wash / Water Service' },
                    { value: 'Pickup/Drop' },
                ],
            },
            {
                label: 'Bike',
                value: 'Bike',
                subServices: [
                    { value: 'Engine Work' },
                    { value: 'Oil Change' },
                    { value: 'Electrical Work' },
                    { value: 'Brake & Clutch Repair' },
                    { value: 'Wheel Alignment' },
                    { value: 'Chain & Sprocket' },
                    { value: 'Battery & Lights' },
                    { value: 'Wash / Water Service' },
                    { value: 'Pickup/Drop' },
                ],
            },
            {
                label: 'Sports Bike',
                value: 'Sports Bike',
                subServices: [
                    { value: 'Engine Work' },
                    { value: 'Oil Change' },
                    { value: 'Electrical Work' },
                    { value: 'Brake & Clutch Repair' },
                    { value: 'Wheel Alignment' },
                    { value: 'Chain & Sprocket' },
                    { value: 'Battery & Lights' },
                    { value: 'Wash / Water Service' },
                    { value: 'Pickup/Drop' },
                ],
            },
            {
                label: 'Electric Bike',
                value: 'Electric Bike',
                subServices: [
                    { value: 'Engine Work' },
                    { value: 'Oil Change' },
                    { value: 'Electrical Work' },
                    { value: 'Brake & Clutch Repair' },
                    { value: 'Wheel Alignment' },
                    { value: 'Chain & Sprocket' },
                    { value: 'Battery & Lights' },
                    { value: 'Wash / Water Service' },
                    { value: 'Pickup/Drop' },
                ],
            },
            {
                label: 'TVS Excel',
                value: 'TVS Excel',
                subServices: [
                    { value: 'Engine Work' },
                    { value: 'Oil Change' },
                    { value: 'Electrical Work' },
                    { value: 'Brake & Clutch Repair' },
                    { value: 'Wheel Alignment' },
                    { value: 'Chain & Sprocket' },
                    { value: 'Battery & Lights' },
                    { value: 'Wash / Water Service' },
                    { value: 'Pickup/Drop' },
                ],
            },
            {
                label: 'Vespa (Vispa)',
                value: 'Vespa (Vispa)',
                subServices: [
                    { value: 'Engine Work' },
                    { value: 'Oil Change' },
                    { value: 'Electrical Work' },
                    { value: 'Brake & Clutch Repair' },
                    { value: 'Wheel Alignment' },
                    { value: 'Chain & Sprocket' },
                    { value: 'Battery & Lights' },
                    { value: 'Wash / Water Service' },
                    { value: 'Pickup/Drop' },
                ],
            },
        ],
        engineCC: ['Up to 150cc', '150–350cc', 'Above 350cc'],
        brandExpertise: ['Hero',
            'Honda',
            'Bajaj',
            'Yamaha',
            'TVS',
            'Suzuki',
            'Royal Enfield',
            'KTM',
            'Husqvarna',
            'Jawa',
            'Yezdi',
            'Triumph',
            'Harley-Davidson',
            'BMW Motorrad',
            'Ducati',
            'Kawasaki',
            'Benelli',
            'CFMoto',
            'Zontes',
            'QJ Motor',
            'Keeway',
            'Indian Motorcycle',
            'MV Agusta',
            'Aprilia',
            'Vespa',
            'Lambretta',
            'Matter',
            'Ultraviolette',
            'Revolt',
            'Oben',
            'Ola Electric',
            'Ather',
            'Simple Energy',
            'Pure EV']
        ,
        workshopType: ['Garage', 'On-Road'],
        fuelType: ['Petrol', 'Electric'],
    },
    {
        profession: { label: '4 Wheeler Mechanic', value: 'Four Wheeler Mechanic' },
        services: [
            {
                label: 'Hatchback',
                value: 'Hatchback',
                subServices: [
                    { value: 'General Service & Oil Change' },
                    { value: 'Engine Overhauling' },
                    { value: 'AC & Cooling System Repair' },
                    { value: 'Electrical/Wiring Work' },
                    { value: 'Brake & Suspension' },
                    { value: 'Clutch/Gearbox' },
                    { value: 'Wheel Alignment' },
                    { value: 'Painting & Denting' },
                    { value: 'Pickup/Drop' },
                ],
            },
            {
                label: 'Sedan',
                value: 'Sedan',
                subServices: [
                    { value: 'General Service & Oil Change' },
                    { value: 'Engine Overhauling' },
                    { value: 'AC & Cooling System Repair' },
                    { value: 'Electrical/Wiring Work' },
                    { value: 'Brake & Suspension' },
                    { value: 'Clutch/Gearbox' },
                    { value: 'Wheel Alignment' },
                    { value: 'Painting & Denting' },
                    { value: 'Pickup/Drop' },
                ],
            },
            {
                label: 'SUV',
                value: 'SUV',
                subServices: [
                    { value: 'General Service & Oil Change' },
                    { value: 'Engine Overhauling' },
                    { value: 'AC & Cooling System Repair' },
                    { value: 'Electrical/Wiring Work' },
                    { value: 'Brake & Suspension' },
                    { value: 'Clutch/Gearbox' },
                    { value: 'Wheel Alignment' },
                    { value: 'Painting & Denting' },
                    { value: 'Pickup/Drop' },
                ],
            },
            {
                label: 'MUV',
                value: 'MUV',
                subServices: [
                    { value: 'General Service & Oil Change' },
                    { value: 'Engine Overhauling' },
                    { value: 'AC & Cooling System Repair' },
                    { value: 'Electrical/Wiring Work' },
                    { value: 'Brake & Suspension' },
                    { value: 'Clutch/Gearbox' },
                    { value: 'Wheel Alignment' },
                    { value: 'Painting & Denting' },
                    { value: 'Pickup/Drop' },
                ],
            },
            {
                label: 'Electric Car',
                value: 'Electric Car',
                subServices: [
                    { value: 'General Service' },
                    { value: 'AC & Cooling System Repair' },
                    { value: 'Electrical/Wiring Work' },
                    { value: 'Brake & Suspension' },
                    { value: 'Wheel Alignment' },
                    { value: 'Painting & Denting' },
                    { value: 'Pickup/Drop' },
                ],
            },
        ],
        engineCC: ['900–1500cc', '1500–2500cc', 'Above 2500cc'],
        brandExpertise: [
            'Maruti Suzuki',
            'Hyundai',
            'Tata',
            'Mahindra',
            'Kia',
            'Honda',
            'Toyota',
            'Renault',
            'Nissan',
            'Volkswagen',
            'Skoda',
            'Ford',
            'Chevrolet',
            'MG',
            'Citroen',
            'Isuzu',
            'Jeep',
            'Datsun',
            'Mitsubishi',
            'Fiat',
            'Opel',
            'Mercedes-Benz',
            'BMW',
            'Audi',
            'Volvo',
            'Jaguar',
            'Land Rover',
            'Lexus',
            'Porsche',
            'Rolls-Royce',
            'Bentley',
            'Lamborghini',
            'Aston Martin',
            'Ferrari'

        ],
        workshopType: ['Garage', 'On-Road'],
        fuelType: ['Petrol', 'Diesel', 'CNG', 'Electric', 'Hybrid'],
    },
    {
        profession: { label: 'Commercial Vehicle Mechanic', value: 'Commercial Vehicle Mechanic' },
        services: [
            {
                label: 'Truck / Lorry',
                value: 'Truck / Lorry',
                subServices: [
                    { value: 'Engine Work' },
                    { value: 'Brake / Suspension' },
                    { value: 'Electrical Wiring' },
                    { value: 'Gearbox / Transmission' },
                    { value: 'Tyre Service' },
                    { value: 'Diesel Pump Work' },
                    { value: 'Hydraulic Repair' },
                    { value: 'Welding & Body Work' },
                ],
            },
            {
                label: 'Tractor',
                value: 'Tractor',
                subServices: [
                    { value: 'Engine Work' },
                    { value: 'Brake / Suspension' },
                    { value: 'Electrical Wiring' },
                    { value: 'Gearbox / Transmission' },
                    { value: 'Tyre Service' },
                    { value: 'Diesel Pump Work' },
                    { value: 'Hydraulic Repair' },
                    { value: 'Welding & Body Work' },
                ],
            },
            {
                label: 'Auto / Goods Carrier',
                value: 'Auto / Goods Carrier',
                subServices: [
                    { value: 'Engine Work' },
                    { value: 'Brake / Suspension' },
                    { value: 'Electrical Wiring' },
                    { value: 'Gearbox / Transmission' },
                    { value: 'Tyre Service' },
                    { value: 'Diesel Pump Work' },
                    { value: 'Hydraulic Repair' },
                    { value: 'Welding & Body Work' },
                ],
            },
            {
                label: 'Bus / Mini Bus',
                value: 'Bus / Mini Bus',
                subServices: [
                    { value: 'Engine Work' },
                    { value: 'Brake / Suspension' },
                    { value: 'Electrical Wiring' },
                    { value: 'Gearbox / Transmission' },
                    { value: 'Tyre Service' },
                    { value: 'Diesel Pump Work' },
                    { value: 'Hydraulic Repair' },
                    { value: 'Welding & Body Work' },
                ],
            },
            {
                label: 'Tempo / Pick-up Van',
                value: 'Tempo / Pick-up Van',
                subServices: [
                    { value: 'Engine Work' },
                    { value: 'Brake / Suspension' },
                    { value: 'Electrical Wiring' },
                    { value: 'Gearbox / Transmission' },
                    { value: 'Tyre Service' },
                    { value: 'Diesel Pump Work' },
                    { value: 'Hydraulic Repair' },
                    { value: 'Welding & Body Work' },
                ],
            },
        ],
        engineCC: ['900-1500CC', '1500-2000CC', 'Above 2000CC'],
        brandExpertise: [
            'Ashok Leyland',
            'Tata',
            'Eicher',
            'Mahindra',
            'BharatBenz',
            'Volvo',
            'Force Motors',
            'Swaraj Mazda (SML Isuzu)',
            'VE Commercial Vehicles',
            'Scania',
            'MAN',
            'AMW (Asia MotorWorks)',
            'Daimler India',
            'Piaggio',
            'Atul Auto',
            'Maruti Suzuki (Commercial)',
            'Isuzu',
            'Mahindra Electric'
        ],
        workshopType: ['Garage', 'On-Road'],
        fuelType: ['Diesel', 'CNG', 'Electric', 'Hybrid'],
    },
    {
        profession: { label: 'Multi-Vehicle Mechanic', value: 'Multi Vehicle Mechanic' },
        vehicleTypes: [
            {
                category: '2 Wheelers',
                engineCC: ['Up to 150cc', '150–350cc', 'Above 350cc'],
                brandExpertise: ['Hero',
                    'Honda',
                    'Bajaj',
                    'Yamaha',
                    'TVS',
                    'Suzuki',
                    'Royal Enfield',
                    'KTM',
                    'Husqvarna',
                    'Jawa',
                    'Yezdi',
                    'Triumph',
                    'Harley-Davidson',
                    'BMW Motorrad',
                    'Ducati',
                    'Kawasaki',
                    'Benelli',
                    'CFMoto',
                    'Zontes',
                    'QJ Motor',
                    'Keeway',
                    'Indian Motorcycle',
                    'MV Agusta',
                    'Aprilia',
                    'Vespa',
                    'Lambretta',
                    'Matter',
                    'Ultraviolette',
                    'Revolt',
                    'Oben',
                    'Ola Electric',
                    'Ather',
                    'Simple Energy',
                    'Pure EV'],
                workshopType: ['Garage', 'On-Road'],
                fuelType: ['Petrol', 'Electric'],
                vehicles: [
                    {
                        label: 'Scooty',
                        value: 'Scooty',
                        subServices: [
                            { value: 'General & Engine' },
                            { value: 'Electrical' },
                            { value: 'Brakes, Suspension' },
                            { value: 'Transmission' },
                            { value: 'Tyres & Wheels' },
                            { value: 'Body & Aesthetics' },
                            { value: 'Pickup / Drop' },
                        ],
                    },
                    {
                        label: 'Bike',
                        value: 'Bike',
                        subServices: [
                            { value: 'General & Engine' },
                            { value: 'Electrical' },
                            { value: 'Brakes, Suspension' },
                            { value: 'Transmission' },
                            { value: 'Tyres & Wheels' },
                            { value: 'Body & Aesthetics' },
                            { value: 'Pickup / Drop' },
                        ],
                    },
                    {
                        label: 'Sports Bike',
                        value: 'Sports Bike',
                        subServices: [
                            { value: 'General & Engine' },
                            { value: 'Electrical' },
                            { value: 'Brakes, Suspension' },
                            { value: 'Transmission' },
                            { value: 'Tyres & Wheels' },
                            { value: 'Body & Aesthetics' },
                            { value: 'Pickup / Drop' },
                        ],
                    },
                    {
                        label: 'Electric Bike',
                        value: 'Electric Bike',
                        subServices: [
                            { value: 'General & Battery' },
                            { value: 'Electrical' },
                            { value: 'Brakes, Suspension' },
                            { value: 'Transmission' },
                            { value: 'Tyres & Wheels' },
                            { value: 'Body & Aesthetics' },
                            { value: 'Pickup / Drop' },
                        ],
                    },
                    {
                        label: 'TVS Excel',
                        value: 'TVS Excel',
                        subServices: [
                            { value: 'General & Engine' },
                            { value: 'Electrical' },
                            { value: 'Brakes, Suspension' },
                            { value: 'Transmission' },
                            { value: 'Tyres & Wheels' },
                            { value: 'Body & Aesthetics' },
                            { value: 'Pickup / Drop' },
                        ],
                    },
                    {
                        label: 'Vespa',
                        value: 'Vespa',
                        subServices: [
                            { value: 'General & Engine' },
                            { value: 'Electrical' },
                            { value: 'Brakes, Suspension' },
                            { value: 'Transmission' },
                            { value: 'Tyres & Wheels' },
                            { value: 'Body & Aesthetics' },
                            { value: 'Pickup / Drop' },
                        ],
                    },
                ],
            },
            {
                category: '4 Wheelers',
                engineCC: ['900–1500cc', '1500–2500cc', 'Above 2500cc'],
                brandExpertise: [
                    'Maruti Suzuki',
                    'Hyundai',
                    'Tata',
                    'Mahindra',
                    'Kia',
                    'Honda',
                    'Toyota',
                    'Renault',
                    'Nissan',
                    'Volkswagen',
                    'Skoda',
                    'Ford',
                    'Chevrolet',
                    'MG',
                    'Citroen',
                    'Isuzu',
                    'Jeep',
                    'Datsun',
                    'Mitsubishi',
                    'Fiat',
                    'Opel',
                    'Mercedes-Benz',
                    'BMW',
                    'Audi',
                    'Volvo',
                    'Jaguar',
                    'Land Rover',
                    'Lexus',
                    'Porsche',
                    'Rolls-Royce',
                    'Bentley',
                    'Lamborghini',
                    'Aston Martin',
                    'Ferrari'
                ],
                workshopType: ['Garage', 'On-Road'],
                fuelType: ['Petrol', 'Diesel', 'CNG', 'Electric', 'Hybrid'],
                vehicles: [
                    {
                        label: 'Hatchback',
                        value: 'Hatchback',
                        subServices: [
                            { value: 'General & Engine' },
                            { value: 'Electrical' },
                            { value: 'Brakes, Suspension & Steering' },
                            { value: 'Transmission' },
                            { value: 'Tyres & Wheels' },
                            { value: 'Body & Aesthetics' },
                            { value: 'AC & Cooling' },
                            { value: 'Pickup / Drop' },
                        ],
                    },
                    {
                        label: 'Sedan',
                        value: 'Sedan',
                        subServices: [
                            { value: 'General & Engine' },
                            { value: 'Electrical' },
                            { value: 'Brakes, Suspension & Steering' },
                            { value: 'Transmission' },
                            { value: 'Tyres & Wheels' },
                            { value: 'Body & Aesthetics' },
                            { value: 'AC & Cooling' },
                            { value: 'Pickup / Drop' },
                        ],
                    },
                    {
                        label: 'SUV',
                        value: 'SUV',
                        subServices: [
                            { value: 'General & Engine' },
                            { value: 'Electrical' },
                            { value: 'Brakes, Suspension & Steering' },
                            { value: 'Transmission' },
                            { value: 'Tyres & Wheels' },
                            { value: 'Body & Aesthetics' },
                            { value: 'AC & Cooling' },
                            { value: 'Pickup / Drop' },
                        ],
                    },
                    {
                        label: 'MUV',
                        value: 'MUV',
                        subServices: [
                            { value: 'General & Engine' },
                            { value: 'Electrical' },
                            { value: 'Brakes, Suspension & Steering' },
                            { value: 'Transmission' },
                            { value: 'Tyres & Wheels' },
                            { value: 'Body & Aesthetics' },
                            { value: 'AC & Cooling' },
                            { value: 'Pickup / Drop' },
                        ],
                    },
                    {
                        label: 'Electric Car',
                        value: 'Electric Car',
                        subServices: [
                            { value: 'General & Battery' },
                            { value: 'Electrical' },
                            { value: 'Brakes, Suspension & Steering' },
                            { value: 'Transmission' },
                            { value: 'Tyres & Wheels' },
                            { value: 'Body & Aesthetics' },
                            { value: 'AC & Cooling' },
                            { value: 'Pickup / Drop' },
                        ],
                    },
                ],
            },
        ],
    },
    {
        profession: { label: 'Painter', value: 'Painter' },
        services: [
            { label: 'Accent Wall Painting', value: 'Accent Wall Painting' },
            { label: 'Cabinet Painting', value: 'Cabinet Painting' },
            { label: 'Ceiling Painting', value: 'Ceiling Painting' },
            { label: 'Door Painting', value: 'Door Painting' },
            { label: 'Exterior Painting', value: 'Exterior Painting' },
            { label: 'Fence Painting', value: 'Fence Painting' },
            { label: 'Interior Painting', value: 'Interior Painting' },
            { label: 'Mural Painting', value: 'Mural Painting' },
            { label: 'Spray Painting', value: 'Spray Painting' },
            { label: 'Surface Preparation', value: 'Surface Preparation' },
            { label: 'Trim Painting', value: 'Trim Painting' },
            { label: 'Wall Texturing', value: 'Wall Texturing' },
        ],
    },
    {
        profession: { label: 'Photography', value: 'Photography' },
        services: [
            { label: 'Wedding Photography', value: 'Wedding Photography' },
            { label: 'Pre-Wedding Shoot', value: 'Pre-Wedding Shoot' },
            { label: 'Event Photography', value: 'Event Photography' },
            { label: 'Portrait Session', value: 'Portrait Session' },
            { label: 'Product Shoot', value: 'Product Shoot' },
            { label: 'Real Estate Shoot', value: 'Real Estate Shoot' },
            { label: 'Video Coverage', value: 'Video Coverage' },
            { label: 'Photo Editing & Retouching', value: 'Photo Editing & Retouching' },
            { label: 'Album Design', value: 'Album Design' },
            { label: 'Drone Shoot (Where Allowed)', value: 'Drone Shoot (Where Allowed)' },
        ],
    },
    {
        profession: { label: 'Plumber', value: 'Plumber' },
        services: [
            { label: 'Backflow Prevention', value: 'Backflow Prevention' },
            { label: 'Bathtub Installation', value: 'Bathtub Installation' },
            { label: 'Drain Cleaning', value: 'Drain Cleaning' },
            { label: 'Faucet Installation', value: 'Faucet Installation' },
            { label: 'Gas Line Installation', value: 'Gas Line Installation' },
            { label: 'Garbage Disposal Repair', value: 'Garbage Disposal Repair' },
            { label: 'Leak Repair', value: 'Leak Repair' },
            { label: 'Pipe Installation', value: 'Pipe Installation' },
            { label: 'Sewer Line Repair', value: 'Sewer Line Repair' },
            { label: 'Shower Installation', value: 'Shower Installation' },
            { label: 'Sump Pump Repair', value: 'Sump Pump Repair' },
            { label: 'Toilet Repair', value: 'Toilet Repair' },
            { label: 'Water Heater Installation', value: 'Water Heater Installation' },
            { label: 'Water Heater Repair', value: 'Water Heater Repair' },
            { label: 'Waterproofing', value: 'Waterproofing' },
        ],
    },
    {
        profession: { label: 'RO Water Purifier Services', value: 'RO Water Purifier Services' },
        services: [
            { label: 'RO Installation', value: 'RO Installation' },
            { label: 'RO Uninstallation', value: 'RO Uninstallation' },
            { label: 'Filter Replacement', value: 'Filter Replacement' },
            { label: 'Membrane Replacement', value: 'Membrane Replacement' },
            { label: 'Pump Repair', value: 'Pump Repair' },
            { label: 'UV Lamp Replacement', value: 'UV Lamp Replacement' },
            { label: 'Water Quality Test (TDS)', value: 'Water Quality Test (TDS)' },
            { label: 'Annual Maintenance (AMC)', value: 'Annual Maintenance (AMC)' },
            { label: 'Leak Fixing', value: 'Leak Fixing' },
        ],
    },
    {
        profession: { label: 'Shifting', value: 'Shifting' },
        services: [
            { label: 'Customs Clearance', value: 'Customs Clearance' },
            { label: 'Disposal of Unwanted Items', value: 'Disposal of Unwanted Items' },
            { label: 'Fine Art Moving', value: 'Fine Art Moving' },
            { label: 'Fragile Item Handling', value: 'Fragile Item Handling' },
            { label: 'House Shifting', value: 'House Shifting' },
            { label: 'Loading and Unloading', value: 'Loading and Unloading' },
            { label: 'Office Relocation', value: 'Office Relocation' },
            { label: 'Packing Services', value: 'Packing Services' },
            { label: 'Pet Relocation', value: 'Pet Relocation' },
            { label: 'Piano Moving', value: 'Piano Moving' },
            { label: 'Transportation', value: 'Transportation' },
            { label: 'Unpacking Services', value: 'Unpacking Services' },
            { label: 'Warehouse Storage', value: 'Warehouse Storage' },
        ],
    },
    {
        profession: { label: 'Smart Home Services (CCTV, Wifi)', value: 'Smart Home' },
        services: [
            { label: 'CCTV Installation', value: 'CCTV Installation' },
            { label: 'CCTV Repair & Maintenance', value: 'CCTV Repair & Maintenance' },
            { label: 'Wi-Fi Router Setup', value: 'Wi-Fi Router Setup' },
            { label: 'Mesh Wi-Fi Setup', value: 'Mesh Wi-Fi Setup' },
            { label: 'Smart Doorbell Installation', value: 'Smart Doorbell Installation' },
            { label: 'Smart Lock Installation', value: 'Smart Lock Installation' },
            { label: 'Home Automation Hub Setup', value: 'Home Automation Hub Setup' },
            { label: 'IP Camera Configuration', value: 'IP Camera Configuration' },
            { label: 'Network Troubleshooting', value: 'Network Troubleshooting' },
            { label: 'Video Door Phone Setup', value: 'Video Door Phone Setup' },
        ],
    },
    {
        profession: { label: 'Tutors (Dance, Music, Academic, Yoga, Sports)', value: 'Tutors' },
        services: [
            { label: 'Academic Tutoring (K-12)', value: 'Academic Tutoring (K-12)' },
            { label: 'Competitive Exam Prep', value: 'Competitive Exam Prep' },
            { label: 'Spoken English', value: 'Spoken English' },
            { label: 'Music Lessons (Vocal/Instrument)', value: 'Music Lessons (Vocal/Instrument)' },
            { label: 'Dance Classes', value: 'Dance Classes' },
            { label: 'Yoga & Meditation', value: 'Yoga & Meditation' },
            { label: 'Home Tuition', value: 'Home Tuition' },
            { label: 'Online Classes', value: 'Online Classes' },
            { label: 'Art & Craft', value: 'Art & Craft' },
            { label: 'Coding for Kids', value: 'Coding for Kids' },
        ],
    },
    {
        profession: { label: 'TV Repair', value: 'TV Repair' },
        services: [
            { label: 'Backlight Repair', value: 'Backlight Repair' },
            { label: 'HDMI Port Repair', value: 'HDMI Port Repair' },
            { label: 'LED Repair', value: 'LED Repair' },
            { label: 'Motherboard Repair', value: 'Motherboard Repair' },
            { label: 'Power Supply Repair', value: 'Power Supply Repair' },
            { label: 'Remote Control Repair', value: 'Remote Control Repair' },
            { label: 'Signal Troubleshooting', value: 'Signal Troubleshooting' },
            { label: 'Smart TV Setup', value: 'Smart TV Setup' },
            { label: 'Sound Issues Fixing', value: 'Sound Issues Fixing' },
            { label: 'TV Tuning', value: 'TV Tuning' },
        ],
    },
    {
        profession: { label: 'Water Can Delivery', value: 'Water Can Delivery' },
        services: [
            { label: '20L Can Delivery (One-Time)', value: '20L Can Delivery (One-Time)' },
            { label: 'Monthly Subscription', value: 'Monthly Subscription' },
            { label: 'Emergency Delivery', value: 'Emergency Delivery' },
            { label: 'Dispenser Tap Replacement', value: 'Dispenser Tap Replacement' },
            { label: 'Dispenser Cleaning', value: 'Dispenser Cleaning' },
            { label: 'Stair Delivery (No Lift)', value: 'Stair Delivery (No Lift)' },
        ],
    },
    {
        profession: { label: 'Road Assistance', value: 'Road Assistance' },
        services: [
            { label: 'Vehicle Towing', value: 'Vehicle Towing' },
            { label: 'Puncture Service', value: 'Puncture Service' },
        ],
    },
];

export const professionOptions = professionServiceData.map(({ profession }) => profession);

export default professionServiceData;



